<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <div class="headline">Users</div>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="userItems"
          :rows-per-page-items="[10, 20, 50]"
          :pagination.sync="pagination"
          :total-items="totalUsers"
          :loading="isLoading('load')"
      >
        <!--        :search="search ? search : undefined"-->

        <template v-slot:items="props">
          <td>
            <router-link :to="`/admin/user/${props.item.userid}`" style="text-decoration: none">
            <v-avatar :size="32" class="mr-2">
              <img :src="thumbs[props.item.userid]" v-if="thumbs[props.item.userid]">
              <v-icon v-else class="black--text accent">person</v-icon>
            </v-avatar>
            {{ props.item.userid }}
            </router-link>
            <template v-if="props.item.auth">
              <v-icon class="px-2" color="blue" v-if="props.item.auth !== 'normal'" size="small">star</v-icon>
              <span class="blue--text caption" v-if="props.item.auth === 'superuser'">(Superuser)</span>
            </template>
          </td>
          <!--          <td><template v-if="props.item.login">{{ props.item.login.toDateString() }}</template></td>-->
          <td>
            <v-edit-dialog
                :return-value.sync="props.item.status"
                lazy
                :ref="`editDialog${props.item.userid}`"
            >
              <v-hover>
                <div slot-scope="{ hover }">
                <span :class="statusClass(props.item.status, hover)" class="px-2 py-1">
                  {{ props.item.status }}
                </span>
                  <v-icon :class="{'zero-opacity': !hover}" class="px-2" size="small">edit</v-icon>
                </div>
              </v-hover>
              <template v-slot:input>
                <div class="mt-3 title">Update User Status</div>
                <v-select
                    v-model="props.item.status"
                    :items="statusItems"
                    autofocus
                ></v-select>
                <v-layout>
                  <v-spacer/>
                  <v-btn flat round @click="cancel(props.item)" color="warning">cancel</v-btn>
                  <v-btn depressed round :loading="isLoading('update')" @click="save(props.item)" color="warning">save
                  </v-btn>
                </v-layout>
              </template>
            </v-edit-dialog>
          </td>
          <td class="layout px-0">
            <v-tooltip bottom v-if="props.item.auth === 'normal'">
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="blue lighten-2">
                  <v-icon @click="openAlertDialog('promote', props.item)" dark v-on="on">person_add</v-icon>
                </v-btn>
              </template>
              <span>Promote to admin</span>
            </v-tooltip>

            <v-tooltip bottom v-if="props.item.auth === 'admin'">
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="red lighten-2">
                  <v-icon @click="openAlertDialog('dismiss', props.item)" dark v-on="on">remove_circle_outline</v-icon>
                </v-btn>
              </template>
              <span>Dismiss admin</span>
            </v-tooltip>

          </td>
          <td>{{ props.item.scoins }}</td>
          <td>{{ props.item.SCoinsWon }}</td>
          <td>{{ props.item.SCoinsLost }}</td>
          <td>{{ props.item.numPlayedInstaplays }}</td>
          <td>{{ props.item.numPublishedInstaplays }}</td>

        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="alertDialog.dialog" max-width="320">
      <v-card>
        <v-card-title class="headline">{{alertDialog.message}}</v-card-title>
        <v-card-text v-if="alertDialog.item" class="pa-0 pb-3">
          <v-list-tile avatar class>
            <v-list-tile-avatar>
              <img :src="thumbs[alertDialog.item.userid]" v-if="thumbs[alertDialog.item.userid]">
              <v-icon v-else class="black--text accent">person</v-icon>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="alertDialog.item.userid" style="width: auto"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="warning"
              flat="flat"
              round
              @click="alertDialog.dialog = false"
          >
            {{alertDialog.secondary}}
          </v-btn>

          <v-btn
              color="warning"
              depressed
              round
              @click="doDialogAction"
              :loading="isLoading('update')"
          >
            {{alertDialog.primary}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex";

    export default {
        name: "Users",
        data() {
            return {
                totalUsers: 0,
                pagination: {
                    sortBy: 'auth',
                    descending: true
                },
                userItems: [],
                search: '',
                userListReady: false,
                alertDialog: {
                    dialog: false,
                    message: '',
                    action: '',
                    primary: 'yes',
                    secondary: 'no',
                    item: ''
                },
                statusItems: [
                    "active", "suspended"
                ],
                headers: [
                    {
                        text: 'User',
                        align: 'left',
                        sortable: false,
                        value: 'fname'
                    },
                    // {text: 'Last Login', value: 'login'},
                    {text: 'Status', value: 'status'},
                    {text: 'Actions', value: 'name', sortable: false},
                    {text: 'current SCoins', value: 'scoins'},
                    {text: 'SCoins Won', value: 'SCoinsWon'},
                    {text: 'SCoins Lost', value: 'SCoinsLost'},
                    {text: 'Played Instaplays', value: 'numPlayedInstaplays'},
                    {text: 'Published Instaplays', value: 'numPublishedInstaplays'},
                ]
            }
        },
        computed: {
            ...mapState('admin', ['users']),
            ...mapGetters('admin', ['isLoading', 'isSuccess']),
            ...mapState('thumbnails', ['thumbs']),
            sortedUsers() {
                return this.users.concat().sort((a, b) => {
                    return b.auth.length - a.auth.length
                })
            }
        },
        methods: {
            ...mapActions('admin', ['updateUser', 'getUserIDs', 'loadUsers']),
            statusClass(status, hover) {
                return status === 'active' ? hover ? ['green', 'white--text', 'v-btn--round'] : 'green--text' : hover ? ['red', 'white--text', 'v-btn--round'] : 'red--text'
            },
            async getUserStats(all = false) {
                const {sortBy, descending, page, rowsPerPage} = this.pagination
                if (all) {
                    await this.loadUsers({})
                } else {
                    const from = (page - 1) * rowsPerPage
                    const to = from + rowsPerPage
                    await this.loadUsers({from, to})
                }
                this.userItems = this.users
                if (this.pagination.sortBy) {
                    this.userItems = this.users.sort((a, b) => {
                        const sortA = a[sortBy]
                        const sortB = b[sortBy]

                        if (descending) {
                            if (sortA < sortB) return 1
                            if (sortA > sortB) return -1
                            return 0
                        } else {
                            if (sortA < sortB) return -1
                            if (sortA > sortB) return 1
                            return 0
                        }
                    })
                }
                if (rowsPerPage > 0) {
                    this.userItems = this.userItems.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                }
            },
            openAlertDialog(action, item) {
                this.alertDialog.item = item
                this.alertDialog.action = action
                switch (action) {
                    case 'promote':
                        this.alertDialog.message = `Do you want to make ${item.fname} admin?`
                        break
                    case 'dismiss':
                        this.alertDialog.message = `Do you want to dismiss ${item.fname} as admin?`
                        break
                }
                this.alertDialog.dialog = true
            },
            doDialogAction() {
                switch (this.alertDialog.action) {
                    case 'promote':
                        this.promoteUser(this.alertDialog.item)
                        break
                    case 'dismiss':
                        this.dismissAdmin(this.alertDialog.item)
                        break
                }
                this.alertDialog.dialog = false
            },
            promoteUser(item) {
                this.updateUser({
                    key: 'auth',
                    val: 'admin',
                    id: item.userid
                })
            },
            dismissAdmin(item) {
                this.updateUser({
                    key: 'auth',
                    val: 'normal',
                    id: item.userid
                })
            },
            save(item) {
                this.updateUser({
                    key: 'status',
                    val: item.status,
                    id: item.userid
                }).then(() => {
                    if (this.isSuccess) {
                        this.$refs[`editDialog${item.userid}`].save(item.status)
                    }
                })
            },
            cancel(item) {
                this.$refs[`editDialog${item.userid}`].cancel()
            }
        },
        async mounted() {
            this.userListReady = false
            await this.getUserIDs()
            this.totalUsers = this.users.length
            await this.getUserStats()
            this.userListReady = true
        },
        watch: {
            pagination: {
                handler(val, oldVal) {
                    if (this.userListReady) {
                        if (val.page !== oldVal.page || val.rowsPerPage !== oldVal.rowsPerPage)
                            this.getUserStats()
                        else if (oldVal.sortBy !== undefined)
                            if (val.sortBy !== oldVal.sortBy || val.descending !== oldVal.descending)
                                this.getUserStats(true)
                    }
                },
                deep: true
            }
        },
    }
</script>

<style scoped>
  .zero-opacity {
    opacity: 0;
  }
</style>
